const api = {
  GET_LIST_AUDIT_TRAIL_PORTAL_ADMIN: '/index.php?r=api/v1/system_log/audit-trail/portal-admin',
};

export default api;
